// @ts-check
import api from '../utils/apiClient';

/**
 * POST to an entity's bulk endpoint using the shared body shape.
 * @param {string} path - e.g. '/api/admin/reviews/bulk'
 * @param {{ ids: string[], action: string, params?: object }} body
 * @returns {Promise<{ requested: number, succeeded: string[], failed: { id: string, reason: string }[] }>}
 */
export const runBulk = (path, { ids, action, params = {} }) => api.post(path, { ids, action, params });

/**
 * Turn a bulk result into one toast: success when everything worked, warning listing
 * the first few reasons when some ids failed, error when all of them did.
 * @param {{ succeeded?: string[], failed?: { id: string, reason: string }[] }} result
 * @param {string} verb - past tense, e.g. 'approved'
 * @param {string} [noun]
 * @returns {{ type: 'success' | 'warning' | 'error', message: string }}
 */
export const summarizeBulkResult = (result, verb, noun = 'item') => {
  const ok = result?.succeeded?.length ?? 0;
  const failed = result?.failed ?? [];
  const plural = (n) => `${n} ${noun}${n === 1 ? '' : 's'}`;
  if (failed.length === 0) return { type: 'success', message: `${plural(ok)} ${verb}` };

  const reasons = [...new Set(failed.map((f) => f.reason))].slice(0, 3).join('; ');
  const type = ok === 0 ? 'error' : 'warning';
  const lead = ok === 0 ? `None ${verb}` : `${plural(ok)} ${verb}`;
  return { type, message: `${lead}, ${failed.length} failed: ${reasons}` };
};

/**
 * Show the summary through the admin toast context.
 * @param {any} toast - value of useToast()
 */
export const reportBulkResult = (toast, result, verb, noun) => {
  const { type, message } = summarizeBulkResult(result, verb, noun);
  toast[type](message);
};
